import { TemplatePage } from '@/components/layout/TemplatePage'
import html from './template/Portfolio.html?raw'

export function Portfolio() {
  return <TemplatePage html={html} />
}
